import * as React from 'react';
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { TaxDeduction } from "../../../../TaxDeduction";
import { Modal } from '../../../../Modal';
import * as main from "../../styles/main.module.scss";
import * as screen1 from "./style.module.scss";
export const Screen1 = ({ widget, free=false, accessLimited }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <header className={screen1.screen1}>
      <div className="container">

        <HeaderLogoAndTel logo={"orange"} phoneColor={"#fff"}/>

        <div className={screen1.screen1_suptitle}>Онлайн-курс</div>
        <h1 className={screen1.screen1_title}>Целеполагание по&nbsp;Smart</h1>
        <div className={screen1.screen1_subtitle}>Для&nbsp;тех, кто&nbsp;хочет достигать своих целей</div>

        <div className={main.btnBlock}>
          <button className={`btn ${main.mainBtn} ${screen1.screen1Btn}`} onClick={()=>{setShowModal(true)}}>
            {
              !free ?
                "Купить"
                :
                "Получить бесплатно"
            }
          </button>
        </div>

        <a href="#result" className={main.btnBlock}>
          <button className={`btn ${main.mainBtn} ${screen1.screen1Btn} ${screen1.screen1BtnNoactive}`}>
            Узнать больше
          </button>
        </a>

        {
          !free && <TaxDeduction margin={"30px 0 0"}/>
        }
        { accessLimited && <p style={{ margin: "30px 0 0" }}>Бесплатный доступ действителен в&nbsp;течение 7&nbsp;дней</p> }

      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </header>
  );
};
